var map = {
	"./back.png": 1799,
	"./back2.png": 9363,
	"./cups 1.jpg": 6107,
	"./cups 10.jpg": 2583,
	"./cups 2.jpg": 7925,
	"./cups 3.jpg": 4747,
	"./cups 4.jpg": 3704,
	"./cups 5.jpg": 1600,
	"./cups 6.jpg": 1241,
	"./cups 7.jpg": 4188,
	"./cups 8.jpg": 4776,
	"./cups 9.jpg": 2978,
	"./cups king.jpg": 5546,
	"./cups knight.jpg": 8358,
	"./cups page.jpg": 7316,
	"./cups queen.jpg": 2646,
	"./major 0.jpg": 679,
	"./major 1.jpg": 4273,
	"./major 10.jpg": 7471,
	"./major 11.jpg": 3145,
	"./major 12.jpg": 9465,
	"./major 13.jpg": 2387,
	"./major 14.jpg": 8499,
	"./major 15.jpg": 3748,
	"./major 16.jpg": 5724,
	"./major 17.jpg": 4978,
	"./major 18.jpg": 7407,
	"./major 19.jpg": 6097,
	"./major 2.jpg": 1220,
	"./major 20.jpg": 6420,
	"./major 21.jpg": 6641,
	"./major 3.jpg": 2448,
	"./major 4.jpg": 8565,
	"./major 5.jpg": 394,
	"./major 6.jpg": 6252,
	"./major 7.jpg": 3037,
	"./major 8.jpg": 5840,
	"./major 9.jpg": 8851,
	"./pentacles 1.jpg": 4232,
	"./pentacles 10.jpg": 8994,
	"./pentacles 2.jpg": 7006,
	"./pentacles 3.jpg": 5917,
	"./pentacles 4.jpg": 9516,
	"./pentacles 5.jpg": 7847,
	"./pentacles 6.jpg": 5677,
	"./pentacles 7.jpg": 8877,
	"./pentacles 8.jpg": 2741,
	"./pentacles 9.jpg": 9907,
	"./pentacles king.jpg": 3559,
	"./pentacles knight.jpg": 9703,
	"./pentacles page.jpg": 690,
	"./pentacles queen.jpg": 6769,
	"./swords 1.jpg": 2941,
	"./swords 10.jpg": 1457,
	"./swords 2.jpg": 5032,
	"./swords 3.jpg": 6687,
	"./swords 4.jpg": 1777,
	"./swords 5.jpg": 7702,
	"./swords 6.png": 3256,
	"./swords 7.jpg": 7539,
	"./swords 8.jpg": 2075,
	"./swords 9.jpg": 5954,
	"./swords king.jpg": 7822,
	"./swords knight.jpg": 5313,
	"./swords page.jpg": 172,
	"./swords queen.jpg": 2267,
	"./wands 1.jpg": 3721,
	"./wands 10.jpg": 7729,
	"./wands 2.jpg": 5791,
	"./wands 3.jpg": 1255,
	"./wands 4.jpg": 7959,
	"./wands 5.jpg": 4873,
	"./wands 6.jpg": 35,
	"./wands 7.jpg": 8691,
	"./wands 8.jpg": 9770,
	"./wands 9.jpg": 7404,
	"./wands king.jpg": 6573,
	"./wands knight.jpg": 7302,
	"./wands page.jpg": 2585,
	"./wands queen.jpg": 6722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8979;